module.exports = __webpack_public_path__ + "img/empty.5b864b5d.png";